import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader, ListGroupItem, ListGroup} from "reactstrap";
import { getUsersId, deleteUserKasm, getAdminUsageDump, getUserGroupSettings } from "../../../actions/actionAdminUser";
import { getUserImagesEx } from "../../../actions/actionDashboard";
import {setUsagePageInfo} from "../../../actions/actionUser"
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../../components/Table/Table";
import { NotificationManager } from "react-notifications";
import Proptypes from "prop-types";
import moment from "moment";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";
import _ from "lodash";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: false},
    {name: "ViewUser",path:"/viewuser",isActive: true},
];

class ViewUser extends Component{
    constructor(props){
        super(props);

        this.state = {
            modal: false,
            modalreset: false,
            kasmId: null,
            user: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteKasm = this.deleteKasm.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    deleteConfirm(kasmId){
        this.setState({modal: !this.state.modal,
            kasmId: kasmId});
    }

    deleteKasm(){
        this.props.deleteUserKasm(this.state.kasmId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    toggle(){
        this.setState({modal: !this.state.modal});
    }

    handleDeleteSuccess(){
        const {deleteUserKasmErrorMessage} = this.props;
        if(deleteUserKasmErrorMessage) {
            NotificationManager.error(deleteUserKasmErrorMessage,"Delete Kasm", 3000);
        }
        else{
            this.setState({modal: false});
            this.props.getUsersId();
            NotificationManager.success("Successfully Deleted User","Delete Kasm", 3000);
        }
    }

    handleDeleteError(){
        const {deleteUsersKasmError} = this.props;
        if(deleteUsersKasmError){
            NotificationManager.error(deleteUsersKasmError,"Delete Kasm", 3000);
        }
        else{
            NotificationManager.error("Failed to Delete User","Delete Kasm", 3000);
        }
    }

   async componentDidMount() {
        const { response } = await this.props.getUsersId(this.props.match.params.id);

        this.props.getUserImagesEx({
            username: response.user.username
        });

        this.props.getUserGroupSettings({
            username: response.user.username
        });

        this.props.getAdminUsageDump(this.props.match.params.id);
    }

    renderKasms(kasms){
        if(kasms){
            return(
                kasms.map((kasm, i )=>
                    <tr key={i}> 
                        <td>{kasm.kasm_id}</td>
                        <td>{moment.utc(kasm.start_date).local().format("L h:mm A")}</td>
                        <td>{moment.utc(kasm.expiration_date).local().format("L h:mm A")}</td>
                        <td>{moment.utc(kasm.keepalive_date).local().format("L h:mm A")}</td>
                    </tr>
                ));
        }
    }

    renderGroups(groups){
        if (groups){
            return(
                groups.map((group, i)  => 
                    <ListGroupItem key={i}>Group Name : {group.name}</ListGroupItem>
                ));
        }
    }

    renderResultantGroupsSettings() {
        const data = this.props.groupSettings || [];
       
        const columns = [
            {
                type: "text",
                accessor: "name",
                name: "Name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "value",
                name: "Value",
                filterable: true,
                sortable: true,
                cell: (data) => {
                    if (data.value === true) {
                      return "True";
                    } else if (data.value === false) {
                      return "False"
                    } else if (data.value === "") {
                      return "-";
                    } else if (typeof data.value === "object") {
                      return JSON.stringify(data.value, null, 2);
                    } else {
                      return data.value;
                    }
                }
            },
            {
                type: "text",
                accessor: "value_type",
                name: "Type",
                filterable: true,
                sortable: true
            },
        ];

        return (
            <React.Fragment>
                <DataTable
                    id="user-settings"
                    data={data}
                    columns={columns}
                />
            </React.Fragment>
        )
    }

    renderResultantGroupsImages() {
        const data = this.props.availableKasms || [];

        const columns = [
            {
                type: "text",
                accessor: "friendly_name",
                name: "Image",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "name",
                name: "Name",
                filterable: true,
                sortable: true
            }
        ];

        return (
            <React.Fragment>
                <DataTable
                    id="user-images"
                    data={data}
                    columns={columns}
                />
            </React.Fragment>
        )
    }

    renderUsageDetails() {
        const data = _.get(this.props.usageDump, "account_dump", []);

        const columns = [
            {
                type: "text",
                accessor: "image_friendly_name",
                name: "Image",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "start_date",
                name: "Created",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "destroyed_date",
                name: "Stopped On",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "destroy_reason",
                name: "Stopped By",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "usage_hours",
                name: "Usage (hours)",
                filterable: true,
                sortable: true
            },
        ];

        return (
            <DataTable
                id="view-user"
                data={data}
                columns={columns}
            />
        )
    }

    render(){
        const { user, usageDumpLoading } = this.props;

        return (
          <div className="profile-page">
            <BreadCrumbCompo routes={routes} />
            <Row>
              <Col sm={{ size: 8, order: 3, offset: 2 }}>
                <Card>
                  <CardHeader>
                    <div className="title-head">
                      <strong>View User</strong>
                    </div>
                    {user ? (
                      <Link
                        className="pull-right"
                        to={{
                          pathname: `/updateuser/${this.props.match.params.id}`,
                        }}
                      >
                        <Button className="reset-btn" size="sm" color="primary">
                          Edit User
                        </Button>{" "}
                      </Link>
                    ) : (
                      " "
                    )}
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs="12">
                        <div className="profile-table">
                          {user ? (
                            <Table>
                              <tbody>
                                <tr>
                                  <td>
                                    <h4>User Name</h4>
                                  </td>
                                  <td>{user.username ? user.username : "-"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>First Name</h4>
                                  </td>
                                  <td>
                                    {user.first_name ? user.first_name : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Last Name</h4>
                                  </td>
                                  <td>
                                    {user.last_name ? user.last_name : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Notes</h4>
                                  </td>
                                  <td>{user.notes ? user.notes : "-"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Locked</h4>{" "}
                                  </td>
                                  <td>
                                    <img
                                      src={user.locked ? iconYes : iconNo}
                                      alt="yesNoIcon"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Disabled</h4>{" "}
                                  </td>
                                  <td>
                                    <img
                                      src={user.disabled ? iconYes : iconNo}
                                      alt="yesNoIcon"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Organization</h4>
                                  </td>
                                  <td>
                                    {user.organization
                                      ? user.organization
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Realm</h4>
                                  </td>
                                  <td>{user.realm ? user.realm : "-"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Created</h4>
                                  </td>
                                  <td>
                                    {moment(user.created).isValid()
                                      ? moment(user.created).format("L h:mm A")
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Last Session</h4>
                                  </td>
                                  <td>
                                    {moment(user.last_session).isValid()
                                      ? moment.utc(user.last_session).local().format(
                                          "L h:mm A"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Phone</h4>
                                  </td>
                                  <td>{user.phone ? user.phone : "-"}</td>
                                </tr>
                                <tr>
                                  <td>
                                    <h4>Two Factor Authentication</h4>
                                  </td>
                                  <td>
                                    <img
                                      src={user.two_factor ? iconYes : iconNo}
                                      alt="yesNoIcon"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          ) : (
                            " "
                          )}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                {user && user.groups && user.groups.length > 0 ? (
                  <Card>
                    <div>
                      <CardHeader>
                        <div className="title-head">
                          <strong>Groups</strong>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <ListGroup>{this.renderGroups(user.groups)}</ListGroup>
                      </CardBody>
                    </div>
                  </Card>
                ) : (
                  " "
                )}

                <Card>
                    <div>
                        <CardHeader>
                            <div className="title-head">
                                <strong>Resultant Group Settings</strong>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ListGroup>{this.renderResultantGroupsSettings()}</ListGroup>
                        </CardBody>
                    </div>
                </Card>

                <Card>
                    <div>
                        <CardHeader>
                            <div className="title-head">
                                <strong>Resultant Group Images</strong>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ListGroup>{this.renderResultantGroupsImages()}</ListGroup>
                        </CardBody>
                    </div>
                </Card>

                {user && user.kasms && user.kasms.length > 0 ? (
                  <Card>
                    <div>
                      <CardHeader>
                        <strong>Active Sessions</strong>
                      </CardHeader>
                      <CardBody>
                        <Row>
                          <Col xs="12">
                            <Table bordered responsive className="align_top">
                              <thead>
                                <tr>
                                  <th>Id</th>
                                  <th>Start Date</th>
                                  <th>Expiration Date</th>
                                  <th>Last Accessed</th>
                                </tr>
                              </thead>
                              <tbody>
                                {user ? this.renderKasms(user.kasms) : " "}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </CardBody>
                    </div>
                  </Card>
                ) : (
                  " "
                )}

                {!usageDumpLoading ? (
                  <Card>
                    <div>
                      <CardHeader>
                        <div className="title-head">
                          <strong>Session Usage Details:&nbsp;</strong> Last 30 Days
                        </div>
                      </CardHeader>
                      <CardBody className="p-0">
                        {this.renderUsageDetails()}
                      </CardBody>
                    </div>
                  </Card>
                ) : (
                  " "
                )}

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.deleteConfirm}
                  className={this.props.className}
                >
                  <ModalHeader toggle={this.deleteConfirm}>
                    Delete Kasm
                  </ModalHeader>
                  <ModalBody>
                    {" "}
                    Confirm Delete Session - {"kasm name goes here"}?
                  </ModalBody>
                  <ModalFooter>
                    <Button onClick={this.deleteKasm} size="sm" color="danger">
                      {" "}
                      <i className="fa fa-trash"></i> Delete
                    </Button>
                    <Button onClick={this.toggle} size="sm" color="basic">
                      <i className="fa fa-ban"></i> Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </Col>
            </Row>
          </div>
        );
    }
}

ViewUser.propTypes = {
    history: Proptypes.object.isRequired,
    getUsersId: Proptypes.func.isRequired,
    deleteUserKasm: Proptypes.func.isRequired,
    user: Proptypes.object,
    deleteUserKasmErrorMessage: Proptypes.func,
    deleteUsersKasmError: Proptypes.func,
    match: Proptypes.object,
    className: Proptypes.func
};


export default connect(state =>
    ({
        user: state.admin.user || null,
        deleteUserKasmErrorMessage: state.admin.deleteUserkasmErrorMessage || null,
        deleteUsersKasmError: state.admin.deleteUsersKasmError || null,
        usageDump: state.user.usageDump,
        usageDumpLoading: state.user.usageDumpLoading,
        usageDumpError: state.user.usageDumpError,
        pages : {pageSize : state.user.pageSize, pageNo : state.user.pageNo},
        availableKasms: state.dashboard.availableKasms || null,
        groupSettings: state.dashboard.clientGroupSettings || null
    }),
dispatch => 
    ({  
        getUsersId: (data) => dispatch(getUsersId(data)),
        getUserImagesEx: (data) => dispatch(getUserImagesEx(data)),
        getUserGroupSettings: (data) => dispatch(getUserGroupSettings(data)),
        deleteUserKasm: (kasmId) => dispatch(deleteUserKasm(kasmId)),
        getAdminUsageDump: (userId) => dispatch(getAdminUsageDump(userId)),
        setPageInfo : (data)=> dispatch(setUsagePageInfo(data)),

    }))(ViewUser);